import React, { useState, useEffect } from "react";
import "moment/locale/es";
import { SliderHome } from "../../components/sliderHome/sliderHome";
import { companyPostService } from "../../services/companyPost.service";
import { courseViewService } from "../../services/courseView.service";
import { backendService } from "../../services/backend.service";
import { CardMain } from "../../components/cardMain/cardMain";
import "@splidejs/react-splide/dist/css/splide-core.min.css";
import { RewardsHome } from '../../components/rewardsHome/rewardsHome';
import { Link } from "react-router-dom";
import {useValidTokenFromStorage} from "../../hooks/authHook";
import useWindowViewport from "../../hooks/useWindowViewport";
import PlecaRC from "../../components/plecaRC/plecaRC";

export function Home() {
  const [lastPost, setLastPost] = useState({});
  const [directoryItems, setDirectoryItems] = useState([]);
  const [auditoriumItems, setAuditoriumItems] = useState([]);
  const [ourWorld, setOurWorld] = useState([]);
  const [lastCourse, setLastCourse] = useState([]);
  const [myModal, setMyModal] = useState("inShow");
  const validateToken = useValidTokenFromStorage();
  const {windowWidth} = useWindowViewport();
  const [overlay, setOverlay] = useState(false);

  useEffect(() => {
    backendService.widgets().then((data) => {
      if (data && data.auditoriumWidget && data.auditoriumWidget.length > 0) {
        let auditoriumItems = data.auditoriumWidget.map(({ data }) => data);
        let listSorted = auditoriumItems.sort(function (a, b) {
          return (
            Math.abs(Date.now() - new Date(a.conferenceDate)) -
            Math.abs(Date.now() - new Date(b.conferenceDate))
          );
        });

        setAuditoriumItems(listSorted);
      }
      if (data.surveyWidget != null) {
        let date = new Date();
        date.setDate(date.getDate() + data.surveyWidget.expirationDays);
        data.surveyWidget.expirationDate = date;
      }

      if (data.directoryInfoWidget?.length > 0)
        setDirectoryItems(data.directoryInfoWidget);
    });
    getLatestPost();
    getOrWorld();
    getLatestCourse();
    setTimeout(() => setDoodle(), 8000);
  }, []);

  async function getLatestPost() {
    companyPostService.getLatest(2).then((result) => {
      if (result && result.length > 0) setLastPost(result[0]);
    });
  }

  async function getOrWorld() {
    companyPostService.getLatest(1).then((result) => {
      setOurWorld(result);
    });
  }

  async function getLatestCourse() {
    courseViewService.getLatestCourse().then((result) => {
      let listCourse = JSON.parse(result);
      setLastCourse(listCourse);
    });
  }

  async function setDoodle() {
    setMyModal(myModal === "");
  }

  const toggleOverlay = () => setOverlay(!overlay);

  useEffect(() => {
    if (windowWidth >= 1280) setOverlay(false);
  }, [windowWidth]);

  return (
    <>
      <section className="wrapper__home__page">
        <SliderHome />
        <CardMain />
        <div className="container-page">
          <div className="sec_navs_links">
            <div className="box_nav_link ">
              <div className="item_nav_link jobs">
                <h3 className="">Bolsa de trabajo</h3>
              </div>
              <div className="item_nav_link_info">
                <p>
                  Encuentra oportunidades en empresas que celebran la diversidad
                  y el respeto. ¡Tu talento merece un espacio laboral inclusivo!
                </p>
                <Link to="/job-bank" className="link_btn_home trans jobs">
                  <span>Postúlate</span>
                </Link>
              </div>
            </div>
            <div className="box_nav_link ">
              <div className="item_nav_link groups">
                <h3 className="">Grupos de interés</h3>
              </div>
              <div className="item_nav_link_info">
                <p>
                  Encuentra grupos con tus mismas pasiones, comparte
                  experiencias y aprende en un entorno seguro e inclusivo ¡Las
                  mejores historias comienzan en comunidad!
                </p>
                <Link to="/interest-group" className="link_btn_home trans groups">
                  <span>Únete</span>
                </Link>
              </div>
            </div>
            <div className="box_nav_link ">
              <div className="item_nav_link economy">
                <h3 className="">Economía incluyente</h3>
              </div>
              <div className="item_nav_link_info">
                <p>
                  Conoce emprendimientos de y para la comunidad, ¡hagamos que
                  nuestros consumos beneficien a todes!
                </p>
                <Link to="/directory" className="link_btn_home trans economy">
                  <span>Descubre</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
        {validateToken ? <RewardsHome /> : null}
        {/* <AliadesHome /> */}
        <PlecaRC />
      </section>
    </>
  );
}
